module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag33_1644AT.d8f5003e.jpg";